import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

function SignIn() {
  const history = useHistory();

  useEffect(() => {
    const mockAuthData = {
      access_token: "zana_access_token",
      refresh_token: "zana_refresh_token",
      expires_in: 3600,
      refresh_expires_in: 86400
    };
    localStorage.setItem("accessToken", mockAuthData.access_token);
    localStorage.setItem("refreshToken", mockAuthData.refresh_token);
    localStorage.setItem("accessTokenExpiry", Date.now() + mockAuthData.expires_in * 1000);
    localStorage.setItem("refreshTokenExpiry", Date.now() + mockAuthData.refresh_expires_in * 1000);
    
    const mockUser = {
      token: mockAuthData.access_token,
      username: "default_user"
    };
    localStorage.setItem("user", JSON.stringify(mockUser));
    history.push("/admin/dashboard");
  }, [history]);


  return null;
}

export default SignIn;
